var ns = {
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = ns;